import { Worker } from "types/generated";

export const canDrainWorker = (worker: Worker): boolean => {
  return !worker.drained;
};

export const canUndrainWorker = (worker: Worker): boolean => {
  return worker.drained;
};
